import React from "react";
import { Box,Button, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@emotion/react";
import { useNavigate, useLocation } from "react-router-dom";
import { HRService } from "../../../../config";
import { tokens } from "../../../../theme";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { payrollRunLinesColumns } from "../../../../data/Columns/hrmanagement";

const base_url = HRService.uri;
function PayrollRunLines() {
     // Retrieve data using the key for Fee Notes
     const location = useLocation();
     
     const data = 
        location.state?.payrollData ||
        JSON.parse(localStorage.getItem("PayrollData"));

     const theme = useTheme();
     const colors = tokens(theme.palette.mode);
     const navigate = useNavigate();

     const handleGoBack = () => {
        const backPath = location.state?.from || "/Payroll";
        navigate(backPath);
        };

     // Check if parent data is available before proceeding
     if (!data || !data.id) {
        return (
            <Box m="2px" p="1rem">
                <p>Error: Parent purchase invoice data not found in local storage.</p>
            </Box>
        );
     }
     
     const PayrollRunId = data.id;
     // Define actions for Fee Note Lines
     const actions = {
        require : "id",
         entity: "Payroll Line",
        //  edit: {
        //      key: "EDIT",
        //      button_name: "Edit Line",
        //      Show_Button: true, 
        //      permission: "hasNoPermission", 
        //     roleGroupId: [1, 2, 3, 4], 
        //  },
        //  add: {
        //      key: "ADD",
        //      button_name: "Add",
        //      Show_Button: true, 
        //      permission: "hasNoPermission", 
        //     roleGroupId: [1, 2, 3, 4], 
        //  },
          ViewPayrollLinesDetails: {
      key: "VIEWPAYROLLLINESDETAILS",
      button_name: "View Lines Details",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
     PrintPayslip:{ 
      key: "PRINTPAYSLIP", 
      button_name: "Print Payslip", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
    },
         showStatus: true,
         
         // *** UPDATE: Set modelName to match the GraphQL operation name (without 'query') ***
         modelName: "payrollLinePayrollRunId", 
         dataObject: {
             // *** UPDATE: The input field must match the GraphQL variable (feeNotesLines) ***
             inputFields: {
              
                payrollRunId: PayrollRunId,
                
            
            },
             
             // *** UPDATE: inputObjectName matches the GraphQL operation name (without 'query') ***
             inputObjectName: "payrollLinePayrollRunId", 
             
             // *** UPDATE: inputSubObjectName is the array of results returned by the operation ***
             // Assuming the results array is directly returned by the operation.
             // If the API nests the array under another field, change this accordingly.
             inputSubObjectName: "payrollLine", // Often the same as inputObjectName if the array is directly returned.
             
             returnFields: [
                 "id",
                 "payrollRunId",
                 "employeeId",
                 "employeeName",
                 "grossPay",
                 "taxablePay",
                 "pensionablePay",
                 "totalEarnings",
                 "totalDeductions",
                 "totalStatutoryDeductions",
                 "netPay",
                 "employerContributions",
                 "postedToGL",
                 "glPostDate",
             ],
         },
     };


     const title = `Payroll Lines for Document ${data.documentNumber || data.id}`;
     const subtitle = `View All Lines for this Payroll`;

     return (
         <Box m="2px" p="1rem">
        {/* Floating Back Button */}
            <Fab
                color="secondary"
                aria-label="go back"
                onClick={handleGoBack}
                sx={{
                    position: "fixed",
                    top: 120,      
                    left: 270,     
                    zIndex: 1100,
                    width: 40,
                    height: 40,
                    boxShadow: 3,
                    "&:hover": {
                    boxShadow: 6,
                    },
                }}
            >
            <ArrowBackIcon />
            </Fab>

             <DynamicTable
                 title={title}
                 subtitle={subtitle}
                 // *** NOTE: Replace 'allRelievers' with your actual columns array (e.g., feeNoteLinesColumns) ***
                 columns={payrollRunLinesColumns} 
                 // *** NOTE: Replace 'allUsersQuery' with the actual query that fetches fee note lines (e.g., allFeeNotesLinesQuery) ***
                 //query={allImprestLinesQuery}
                 //FormComponent={ImprestApplicationLineForm}
                 base_url={base_url}
                 actions={actions}
             />
         </Box>
     );
}

export default PayrollRunLines;